import React from 'react';
import ProfilePicture from './ProfilePicture';
import './AboutMeBox.css';

function AboutMeBox() {
    const aboutItems = [
        { icon: '💻', text: 'Full-stack developer specializing in React, Node.js, and modern web technologies', priority: 1 },
        { icon: '🚀', text: 'Building scalable solutions with cloud technologies and microservices architecture', priority: 1 },
        { icon: '🌎', text: 'Iranian-American Software Developer based in Michigan, bringing diverse perspectives to tech', priority: 2 },
        { icon: '🤖', text: 'Passionate about AI/ML integration and automation in web applications', priority: 2 },
        { icon: '🎮', text: 'Currently developing an immersive 3D explorer game using Three.js and WebGL', priority: 3 },
        { icon: '🎓', text: 'Information Technology graduate from Wayne State University with focus on software engineering', priority: 3 },
        { icon: '📚', text: 'Continuous learner, currently exploring cloud architecture and system design', priority: 4 },
        { icon: '🏂', text: 'Adventure seeker - Finding balance through snowboarding and basketball', priority: 4 }
    ].sort((a, b) => a.priority - b.priority);

    const handleResumeDownload = () => {
        const link = document.createElement('a');
        link.href = 'resume.pdf';
        link.download = 'Sourena_Saneei_Resume.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleResumeView = () => {
        window.open('/resume.pdf', '_blank');
    };

    return (
        <div className="about-me-box">
            <ProfilePicture />
            <h2>About Me</h2>
            <ul>
                {aboutItems.map((item, index) => (
                    <li key={index} className={`priority-${item.priority}`}>
                        <span className="item-icon">{item.icon}</span>
                        {item.text}
                    </li>
                ))}
            </ul>
            <div className="button-container">
                <button className="resume-button" onClick={handleResumeDownload}>
                    <span className="button-icon">📄</span>
                    Download Resume
                </button>
                <button className="resume-button" onClick={handleResumeView}>
                    <span className="button-icon">👀</span>
                    View Resume
                </button>
            </div>
        </div>
    );
}

export default AboutMeBox;
